var o = "_icon_1q1xv_1",
    c = "_preloadIcon_1q1xv_15",
    n = {
  icon: o,
  preloadIcon: c
};
export { n as default, o as icon, c as preloadIcon };